module.exports = __webpack_public_path__ + "img/selected4-min.ea8137bc.png";